module.exports = __webpack_public_path__ + "img/skydash.ee2e6cfe.png";